import { Component } from 'react';
import List from "@mui/material/List";
import HRFormListDetail from "./HRFormListDetail";
import { connect } from 'react-redux';
import FormsFilters from './FormsFilters';
import { getFiltersInstance, getInterviewsForHR, getEmployeesByCompanies } from "../../redux/humanResources/humanResourcesActions";

class HumanResourcesTab extends Component {
    constructor(props) {
        super(props);

        let formFilters = this.props.formsFilters[getFiltersInstance(false, false, true)];
        props.getEmployeesByCompanies(formFilters.companies, this.props.activeUser);
        props.getInterviewsForHR(this.props.activeUser, formFilters);
    }

    render() {
        let details = [];

        this.props.interviews.forEach((i) => {
            details.push(
                <HRFormListDetail
                    globalContainer={this.props.globalStore.container}
                    className="form-list-detail"
                    key={i.id}
                    interview={i}
                    humanResourcesTab
                />
            );
        });

        return (
            <div className="container-with-footer">
                <FormsFilters interviews={this.props.interviews} humanResourcesTab />
                <List className="row">{details.map((d) => d)}</List>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        interviews: state.forms.interviewsForHR,
        formsFilters: state.forms.formsFilters,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getInterviewsForHR: (user, formsFilters) => dispatch(getInterviewsForHR(user, formsFilters)),
        getEmployeesByCompanies: (companyIds, user) => dispatch(getEmployeesByCompanies(companyIds, user))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HumanResourcesTab);
